import {Component} from "react";
import PropTypes from "prop-types";
import Glob from "../../libs/Glob.mjs";
import ChevronLeftIcon from "../../media/images/ChevronLeftIcon.mjs";
import ChevronRightIcon from "../../media/images/ChevronRightIcon.mjs";
import "./PagedNavigation.css";
import SkipToNextIcon from "../../media/images/SkipToNextIcon.mjs";
import RewindIcon from "../../media/images/RewindIcon.mjs";
import SkipToPreviousIcon from "../../media/images/SkipToPreviousIcon.mjs";
import ForwardIcon from "../../media/images/ForwardIcon.mjs";

const prefix = "PagedNavigation";

const PagedNavigation = class extends Component {
	static propTypes = {
		/** Total number of pages */
		pages: PropTypes.number.isRequired,
		/** Current page number - can be auto */
		current: PropTypes.number,
		/** Defaults to 4 */
		range: PropTypes.number,
	}
	constructor(props) {
		super(props);
		this.state = {};
		this.uid = Glob.generateUid(prefix);
		this.sort = this.sort.bind(this);
		this.startup = this.startup.bind(this);
		this.checkModifiers = this.checkModifiers.bind(this);
	}
	componentDidMount() {
		Glob.register('currentPage', cp =>{
			if ( this.state.autoPage ) {
				const x = Number( cp.params.page || 1);
				if ( x !== this.state.cp ) this.setState({ cp: x}, this.sort );
			}
		}, this.uid);
		Glob.register('ModifiersPressed', mods => {
			this.checkModifiers(mods).then( changed => {
				if ( changed ) this.sort();
			})
		}, this.uid);
		setTimeout( this.startup);
	}
	componentWillUnmount() {
		Glob.unregister('currentPage', this.uid);
		Glob.unregister('ModifiersPressed', this.uid)
	}
	checkModifiers( mods ) {
		return new Promise( resolve => {
			if ( ! Array.isArray( mods ) ) mods = Glob.getStatus('ModifiersPressed');
			const arrowAdditionalClass = mods.includes( "Meta" )  ? 'best' : (
				( mods.includes( "Alt" )||mods.includes( "Shift" ) ) ? 'power' : 'plain'
			);
			if ( arrowAdditionalClass !== this.state.arrowAdditionalClass ) {
				this.setState({arrowAdditionalClass: arrowAdditionalClass }, ()=>{ resolve(true) } );
			} else {
				resolve(false);
			}
		});
	}
	startup() {
		this.checkModifiers().then( ()=>{
			this.setState( {
				cp: typeof this.props.current === 'number' ? this.props.current : Number( Glob.getPageParam('page') || 1 ),
				qt: Number(this.props.pages ),
				autoPage: typeof this.props.current !== 'number',
				range: Number(this.props.range || 4),
				updated: Date.now()
			}, this.sort );
		})
	}
	sort() {
		const maxPages = this.state.qt;
		if (!maxPages || maxPages < 2) {
			this.setState({ out: null});
			return;
		}
		const cp = this.state.cp;
		let out = [];
		for (let p = 1; p <= maxPages; p++) out.push(p);
		const radius = this.state.range;
		let lastWasFalse = false;
		out = out.map( x => {
			if ( x <= radius ) return x;
			if ( maxPages - x < radius ) return x;
			if ( Math.abs( cp - x) <= Math.min(2,radius -2) ) return x;
			return false;
		}).filter( (x) => {
			if ( x ) {
				lastWasFalse = false;
				return true;
			}
			if ( lastWasFalse ) return false;
			return lastWasFalse = true;
		});
		this.setState({
			updated: Date.now(),
			out: (
			<>
				{ out.map( p=> {
					if ( ! p ) return <span key={Math.random()}>…</span>
					return (
						<div
							key={p}
							className={p === cp ? "current" : "active" }
							onClick={() => Glob.setCurrentPageParam('page', p) }
						>
							{p}
						</div>
					)
				})}
				<span
					style={{marginLeft:"auto"}}
					onClick={ ( e )=> {
						e.stopPropagation();
						let np = cp -1;
						if ( this.state.arrowAdditionalClass === 'best' ) {
							np = 1;
						} else if ( this.state.arrowAdditionalClass === 'power' ) {
							np = Math.max(cp - 10, 1);
						}
						Glob.setCurrentPageParam('page', np)
					}}
					className={ cp === 1 ? "current" : "active "+this.state.arrowAdditionalClass}
				>
					{ this.state.arrowAdditionalClass === 'best' && <SkipToPreviousIcon />}
					{ this.state.arrowAdditionalClass === 'power' && <RewindIcon />}
					{ this.state.arrowAdditionalClass === 'plain' && <ChevronLeftIcon />}
				</span>
				<span
					onClick={ ( e )=> {
							e.stopPropagation();
						let np = cp +1;
						if ( this.state.arrowAdditionalClass === 'best' ) {
							np = maxPages;
						} else if ( this.state.arrowAdditionalClass === 'power' ) {
							np = Math.min(cp + 10, maxPages);
						}
						Glob.setCurrentPageParam('page', np)
					}}
					className={ cp === maxPages ? "current" : "active "+this.state.arrowAdditionalClass}
				>
					{ this.state.arrowAdditionalClass === 'best' && <SkipToNextIcon />}
					{ this.state.arrowAdditionalClass === 'power' && <ForwardIcon />}
					{ this.state.arrowAdditionalClass === 'plain' && <ChevronRightIcon />}
				</span>
			</>
		)});
	}
	render() {
		if ( ! this.props.pages || isNaN(Number(this.props.pages)) || Number(this.props.pages) < 2 ) return null;
		if ( Number(this.props.pages) !== this.state.qt ) {
			setTimeout( this.startup );
			return null;
		}
		return(
			<div
				key={`upd-${this.state.updated}`}
				className={prefix}
				onContextMenu={ e => e.preventDefault() }
			>
				{ this.state.out }
			</div>
		);
	}
}

export default PagedNavigation;